module.exports = __webpack_public_path__ + "img/image_2023_03_30T11_47_00_253Z.48e8ce1d.png";